import { API_GET, DBRequest } from '../../../api/api';

/**
 * Request a fresh re-authentication URL for an email inbox and redirect to it.
 * The backend returns an OAuth `authUrl` for providers that support it; when no
 * URL is returned (e.g. IMAP/password accounts) the caller-supplied
 * `onNoAuthUrl` fallback is invoked instead.
 *
 * @param {object}   params
 * @param {object}   params.config      app config from useConfig()
 * @param {string|number} params.inboxId  email-credentials id
 * @param {function} [params.onNoAuthUrl] fallback when no authUrl is returned
 */
export function reauthenticateInbox({ config, inboxId, onNoAuthUrl }) {
  DBRequest({
    config,
    path: `email-credentials/${inboxId}/re-authenticate`,
    method: API_GET,
    onResponse: (res) => {
      const url = res.data?.authUrl;
      if (url) {
        window.location.assign(url);
      } else {
        onNoAuthUrl?.();
      }
    },
  });
}
